import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule, LocationStrategy, HashLocationStrategy } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './components/app.component';
import { GlobalExceptionHandler } from './shared/popups/globalexceptionhandler/globalexceptionhandler';
import { DatePipe } from '@angular/common';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DatabasesResolver } from './shared/resolvers/databases.resolver';
import { GlobalExceptionHandlerModule } from './shared/popups/globalexceptionhandler/globalexceptionhandler.module';
import { ThemeModule } from './theme/theme.module';
import { NgxUiLoaderModule, NgxUiLoaderRouterModule } from 'ngx-ui-loader';
import * as PlotlyJS from 'plotly.js-dist-min'; 
import { PlotlyModule } from 'angular-plotly.js'; 




PlotlyModule.plotlyjs = PlotlyJS;

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    // Add Angular modules here.
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    PlotlyModule,
     //loader
     NgxUiLoaderModule,
     NgxUiLoaderRouterModule.forRoot({
       showForeground: true,
     }),
     //

    // Add application modules here..
    GlobalExceptionHandlerModule,
    ThemeModule,

    // Add External modules here.
    //Just replace positionClass with 'toast-top-right' if you want to change toast position.
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
      closeButton: true
    }),
  ],
  providers: [
    Location, { provide: LocationStrategy, useClass: HashLocationStrategy },
    DatabasesResolver,
    DatePipe,
    { provide: ErrorHandler, useClass: GlobalExceptionHandler },
    Title
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
